var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M21.805 10.041H21V10H12v4h5.652c-0.825 2.329 -3.04 4 -5.652 4 -3.313 0 -6 -2.687 -6 -6s2.687 -6 6 -6c1.53 0 2.921 0.577 3.981 1.52l2.829 -2.829C17.023 3.026 14.634 2 12 2 6.478 2 2 6.478 2 12s4.478 10 10 10 10 -4.478 10 -10c0 -0.67 -0.069 -1.325 -0.195 -1.958z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D00",
    d: "m3.153 7.346 3.285 2.409C7.327 7.554 9.48 6 12 6c1.53 0 2.921 0.577 3.981 1.52l2.829 -2.829C17.023 3.026 14.634 2 12 2 8.159 2 4.828 4.168 3.153 7.346z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M12 22c2.583 0 4.93 -0.989 6.705 -2.596l-3.095 -2.619A5.955 5.955 0 0 1 12 18c-2.601 0 -4.809 -1.659 -5.641 -3.973l-3.261 2.513C4.753 19.778 8.114 22 12 22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M21.805 10.041H21V10H12v4h5.652a6.02 6.02 0 0 1 -2.043 2.785l0.002 -0.001 3.095 2.619C18.485 19.602 22 17 22 12c0 -0.67 -0.069 -1.325 -0.195 -1.958z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.b6b1d32052203ac83cf8e8441023db3c.svg";
export { ForwardRef as ReactComponent };